export default __webpack_public_path__ + "static/media/login1.939753bb.svg";